angular.module('ecrd.record.bulk').component('recordBulk', {
    controller: 'RecordBulkController',
    templateUrl: 'modules/record-bulk/components/record-bulk/template.html',
    bindings: {
        // Parámetros dels listado formateados como un string
        sdkParameters: '<',
    },
});
